<template>
    <div>
        <tabs v-model="activeTab" nav-style="pills" justified>
            <tab header="Grille d’audit" v-if="!currentTemplate.defaultTemplate">
                <br/>
                <ul class="list-unstyled">
                    <li v-for="(criteria, index) in criterias" :key="criteria.id">
                        <div class="form-group row">
                            <div class="col-md-2">
                                <label>Critère {{ index + 1 }} :</label>
                            </div>
                            <div v-if="!isInUse && !isReady">
                                <div class="col-md-8">
                                    <quill-editor :content="criteria.label" @change="onCriteriaEditorChange(index, $event)" @ready=""></quill-editor>
                                    <div style="margin-top:10px" class="well well-lg">
                                        <h4 class="text-center">{{ "Critère " + (index + 1) }}/{{ criterias.length }}</h4>
                                        <span v-html="criteria.label"></span>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <button class="btn btn-danger" type="button" @click="deleteCriteria(index)">
                                        Supprimer
                                    </button>
                                </div>
                            </div>
                            <div class="col-md-10" v-else>
                                <p v-html="criteria.label"></p>
                            </div>
                        </div>
                    </li>
                </ul>
                <br/>

                <div class="form-group" v-if="!isInUse && !isReady">
                    <button class="btn btn-default" type="button" @click="addCriteria">+ Ajouter un
                        critère
                    </button>
                </div>
            </tab>
            <tab header="Enquête de satisfaction" v-if="satisfactionSurveyStatus != 'NONE'">
                <br/>
                    <ul class="list-unstyled">
                        <li v-for="(question, index) in surveyQuestions" :key="question.id">
                            <div class="form-group row">
                                <div :class="!isInUse && !isReady ? 'col-md-9' : '' + ' row'">
                                    <div class="col-md-2">
                                        <label>Question {{ index + 1 }} :</label>
                                    </div>
                                    <div class="col-md-10" v-if="!isInUse && !isReady">
                                        <quill-editor  :content="question.label" @change="onQuestionEditorChange(index, $event)" @ready=""></quill-editor>
                                        <div style="margin-top:10px" class="well well-lg">
                                            <h4 class="text-center">{{ "Question " + (index + 1) }}/{{ surveyQuestions.length }}</h4>
                                            <span v-html="question.label"></span>
                                        </div>
                                    </div>
                                    <p v-else v-html="question.answerType + question.label"></p>
                                </div>
                                <div class="col-md-3" v-if="!isInUse && !isReady">
                                    <div class="col-md-8">
                                        <dropdown :text="questionTypeText(index)" type="primary">
                                            <li @click="changeQuestionType(index, 'APPRECIATION')" v-if="question.answerType != 'APPRECIATION'"><a>Appréciation</a></li>
                                            <li @click="changeQuestionType(index, 'YES_NO')" v-if="question.answerType != 'YES_NO'"><a>Oui/Non</a></li>
                                        </dropdown>
                                    </div>
                                    <div class="col-md-4">
                                        <button class="btn btn-danger" type="button" @click="deleteQuestion(index)">
                                            Supprimer
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <br/>

                    <div class="form-group" v-if="!isInUse && !isReady">
                        <button class="btn btn-default" type="button" @click="addQuestion()">+ Ajouter une
                            question
                        </button>
                    </div>
                </tab>

            </tabs>
        </div>
        <!-- <button @click="submitFormData()">Sauvegarder</button> -->

    </template>

    <script>
        import { quillEditor  as QuillEditor } from 'vue-quill-editor'
        import { tabs as Tabs, tab as Tab, dropdown as Dropdown } from 'vue-strap'

        import 'quill/dist/quill.core.css'
        import 'quill/dist/quill.snow.css'
        import 'quill/dist/quill.bubble.css'

        export default {
            components: {
                QuillEditor,
                Tab,
                Tabs,
                Dropdown
            },
            computed: {
                criterias: {
                    get() {
                        return this.currentTemplate.criterias;
                    },
                    set(value) {
                        this.$store.commit('CURRENT_TEMPLATE_UPDATED', {key: 'criterias', templateData: value});
                    }
                },
                deletedCriterias: function() {
                    return this.$store.state.admin.deletedCriterias;
                },
                surveyQuestions: {
                    get() {
                        return this.currentTemplate.surveyQuestions;
                    },
                    set(value) {
                        this.$store.commit('CURRENT_TEMPLATE_UPDATED', {key: 'surveyQuestions', templateData: value});
                    }
                },
                deletedQuestions: function() {
                    return this.$store.state.admin.deletedQuestions;
                }
            },
            methods: {
                addCriteria() {
                    this.$store.commit('CURRENT_TEMPLATE_UPDATED', {key: 'criterias', key2: "" + this.criterias.length, templateData: {id: null, label: ""}});
                },
                deleteCriteria(criteriaIndex) {
                    if (this.criterias[criteriaIndex].id)
                        this.$store.commit('DELETED_CRITERIAS_UPDATED', this.criterias[criteriaIndex].id);
                    let tmp = this.criterias.slice(0);
                    tmp.splice(criteriaIndex, 1);
                    this.$store.commit('CURRENT_TEMPLATE_UPDATED', {key: 'criterias', templateData: tmp});
                },
                addQuestion() {
                    this.$store.commit('CURRENT_TEMPLATE_UPDATED', {key: 'surveyQuestions',
                        key2: "" + this.surveyQuestions.length,
                        templateData: {id: null, label: "", answerType: "APPRECIATION"}});
                },
                deleteQuestion(questionIndex) {
                    if (this.surveyQuestions[questionIndex].id)
                        this.$store.commit('DELETED_QUESTIONS_UPDATED', this.surveyQuestions[questionIndex].id);
                    let tmp = this.surveyQuestions.slice(0);
                    tmp.splice(questionIndex, 1);
                    this.$store.commit('CURRENT_TEMPLATE_UPDATED', {key: 'surveyQuestions',
                        templateData: tmp});
                },
                onCriteriaEditorChange(criteriaIndex, { html })  {
                    this.$store.commit('CURRENT_TEMPLATE_UPDATED', {key: 'criterias', key2: "" + criteriaIndex, templateData: {id: this.criterias[criteriaIndex].id, label: html}});
                },
                onQuestionEditorChange(questionIndex, { html })  {
                    this.$store.commit('CURRENT_TEMPLATE_UPDATED', {key: 'surveyQuestions',
                        key2: "" + questionIndex,
                        templateData: {id: this.surveyQuestions[questionIndex].id, label: html, answerType: this.surveyQuestions[questionIndex].answerType}});
                },
                changeQuestionType(questionIndex, newType)  {
                    this.$store.commit('CURRENT_TEMPLATE_UPDATED', {key: 'surveyQuestions',
                        key2: "" + questionIndex,
                        templateData: {id: this.surveyQuestions[questionIndex].id, label: this.surveyQuestions[questionIndex].label, answerType: newType}});
                },
                questionTypeText: function(questionIndex)  {
                    let type = this.surveyQuestions[questionIndex].answerType;
                    if (type == 'APPRECIATION')
                        return 'Appréciation';
                    else if (type = 'YES_NO')
                        return 'Oui/Non';
                }
            },
            props: ['currentTemplate', 'satisfactionSurveyStatus', 'isInUse', 'isReady'],
            data: function()  {
                return {
                    activeTab: 0,
                    editorOption: {
                    }
                };
            }
        };
    </script>

    <style>
        .ql-container .ql-editor {
            min-height: 20em;
            padding-bottom: 1em;
            max-height: 25em;
        }
    </style>